import uuidv4 from 'uuid/v4'
import { getUserId, makeCookieStorage } from '../auth'

export const SESSION_LIMIT = 30 * 60 * 1000
export const SESSION_KEY = 'adoptionSessionId'
const storage = makeCookieStorage()

// Reads and legacy log requests do not prolong a human activity session.
export const getSessionContext = (touch = false) => {
  const userId = String(getUserId() || '')
  if (!userId) return null
  const now = Date.now()
  let session
  try { session = JSON.parse(storage.getItem(SESSION_KEY)) } catch (error) {}
  if (!session || session.userId !== userId || !Number.isFinite(session.startedAt) || session.startedAt > session.last ||
      !Number.isFinite(session.last) || now < session.last || now - session.last >= SESSION_LIMIT) {
    if (!touch) return null
    session = { userId, sessionId: uuidv4(), startedAt: now, last: now }
  }
  if (touch) session.last = now
  try { storage.setItem(SESSION_KEY, JSON.stringify(session)) } catch (error) {}
  return {
    version: 1, source: 'informed', session_id: session.sessionId,
    session_started_at: new Date(session.startedAt).toISOString(),
  }
}

export const getSessionId = () => (getSessionContext() || {}).session_id || ''
